import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "z-50 w-11/12 mx-auto overflow-y-auto bg-white rounded shadow-lg modal-container md:max-w-md" }
const _hoisted_2 = { class: "px-6 py-4 text-left modal-content" }
const _hoisted_3 = { class: "flex items-center justify-between pb-3" }
const _hoisted_4 = { class: "flex justify-end pt-2" }

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppModal',
  setup(__props) {

const open = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = true)),
      class: "px-6 py-2 mt-3 font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-500 focus:outline-none"
    }, " Open Modal "),
    _createElementVNode("div", {
      class: _normalizeClass(`modal ${
        !open.value && 'opacity-0 pointer-events-none'
      } z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center`)
    }, [
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (open.value = false)),
        class: "absolute w-full h-full bg-gray-900 opacity-50 modal-overlay"
      }),
      _createElementVNode("div", _hoisted_1, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "absolute top-0 right-0 z-50 flex flex-col items-center mt-4 mr-4 text-sm text-white cursor-pointer modal-close" }, [
          _createElementVNode("svg", {
            class: "text-white fill-current",
            xmlns: "http://www.w3.org/2000/svg",
            width: "18",
            height: "18",
            viewBox: "0 0 18 18"
          }, [
            _createElementVNode("path", { d: "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" })
          ]),
          _createElementVNode("span", { class: "text-sm" }, "(Esc)")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-2xl font-bold" }, "Modal Title", -1)),
            _createElementVNode("div", {
              class: "z-50 cursor-pointer modal-close",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (open.value = false))
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("svg", {
                class: "text-black fill-current",
                xmlns: "http://www.w3.org/2000/svg",
                width: "18",
                height: "18",
                viewBox: "0 0 18 18"
              }, [
                _createElementVNode("path", { d: "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" })
              ], -1)
            ]))])
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente asperiores sint necessitatibus aspernatur laborum quod ad quibusdam voluptate aliquid molestiae! Cumque voluptatem sint eum, quibusdam cupiditate vero quis. Praesentium, et! ", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (open.value = false)),
              class: "p-3 px-6 py-3 mr-2 text-indigo-500 bg-transparent rounded-lg hover:bg-gray-100 hover:text-indigo-400 focus:outline-none"
            }, " Close "),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (open.value = false)),
              class: "px-6 py-3 font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-500 focus:outline-none"
            }, " Action ")
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})